module.exports = __webpack_public_path__ + "static/media/left.ea61a927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/cybersport/left.png
// module id = 2454
// module chunks = 7